import gql from 'graphql-tag';

export const MUTATION = gql`
  mutation removeDefaultFinancialAccount($accountHolderId: ID!) {
    removeDefaultFinancialAccount(accountHolderId: $accountHolderId)
  }
`;
